import styled from 'styled-components';

export const StyledGifSpinner = styled.div`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* Opcional: deixar circular como o spinner original */
    border-radius: 50%;
    /* Remove seleção da imagem */
    user-select: none;
    -webkit-user-select: none;
    /* Remove arrastar */
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
  }
`;
